module.exports = __webpack_public_path__ + "static/img/EMMCB-CnUyHTnb.8044895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/EMMCB-CnUyHTnb.png
// module id = ynYa
// module chunks = 16